/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsAchievementDtoSchema } from "./achievementDtoSchema.ts";
import { goodLuckCoreDTOsChampionMasteryDtoSchema } from "./championMasteryDtoSchema.ts";
import { goodLuckCoreDTOsFavoriteChampionDtoSchema } from "./favoriteChampionDtoSchema.ts";
import { goodLuckCoreDTOsMatchHistoryDtoSchema } from "./matchHistoryDtoSchema.ts";
import { goodLuckCoreDTOsProfileTournamentTeamDtoSchema } from "./profileTournamentTeamDtoSchema.ts";
import { goodLuckCoreDTOsRiotAccountDtoSchema } from "./riotAccountDtoSchema.ts";
import { goodLuckCoreDTOsSocialLinksDtoSchema } from "./socialLinksDtoSchema.ts";
import { goodLuckCoreDTOsStreamDtoSchema } from "./streamDtoSchema.ts";
import { goodLuckCoreDTOsTeamDtoSchema } from "./teamDtoSchema.ts";
import { goodLuckCoreDTOsUserNotificationSettingsDtoSchema } from "./userNotificationSettingsDtoSchema.ts";
import { goodLuckCoreDTOsUserPrivacySettingsDtoSchema } from "./userPrivacySettingsDtoSchema.ts";
import { goodLuckCoreDTOsUserStatsDtoSchema } from "./userStatsDtoSchema.ts";
import { goodLuckCoreEntitiesProNicknameStyleSchema } from "../entities/proNicknameStyleSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsUserProfileDtoSchema = z.object({
  id: z.string().nullish(),
  username: z.string().nullish(),
  displayName: z.string().nullish(),
  hasPro: z.optional(z.boolean()),
  get proNicknameStyle() {
    return goodLuckCoreEntitiesProNicknameStyleSchema.optional();
  },
  proNicknameColorA: z.string().nullish(),
  proNicknameColorB: z.string().nullish(),
  isVerified: z.optional(z.boolean()),
  platformRoles: z.array(z.string()).nullish(),
  displayRoles: z.array(z.string()).nullish(),
  primaryPlatformRole: z.string().nullish(),
  isOnline: z.optional(z.boolean()),
  status: z.string().nullish(),
  statusExpiresAtUtc: z.iso.datetime().nullish(),
  customStatusText: z.string().nullish(),
  customStatusEmoji: z.string().nullish(),
  customStatusExpiresAtUtc: z.iso.datetime().nullish(),
  avatar: z.string().nullish(),
  banner: z.string().nullish(),
  about: z.string().nullish(),
  location: z.string().nullish(),
  languages: z.array(z.string()).nullish(),
  website: z.string().nullish(),
  get socialLinks() {
    return goodLuckCoreDTOsSocialLinksDtoSchema.optional();
  },
  get stats() {
    return goodLuckCoreDTOsUserStatsDtoSchema.optional();
  },
  get privacy() {
    return goodLuckCoreDTOsUserPrivacySettingsDtoSchema.optional();
  },
  get notifications() {
    return goodLuckCoreDTOsUserNotificationSettingsDtoSchema.optional();
  },
  get achievements() {
    return z.array(goodLuckCoreDTOsAchievementDtoSchema).nullish();
  },
  get favoriteChampions() {
    return z.array(goodLuckCoreDTOsFavoriteChampionDtoSchema).nullish();
  },
  get championMasteries() {
    return z.array(goodLuckCoreDTOsChampionMasteryDtoSchema).nullish();
  },
  get teams() {
    return z.array(goodLuckCoreDTOsTeamDtoSchema).nullish();
  },
  get tournamentTeams() {
    return z.array(goodLuckCoreDTOsProfileTournamentTeamDtoSchema).nullish();
  },
  get riotAccounts() {
    return z.array(goodLuckCoreDTOsRiotAccountDtoSchema).nullish();
  },
  get streams() {
    return z.array(goodLuckCoreDTOsStreamDtoSchema).nullish();
  },
  get matchHistory() {
    return z.array(goodLuckCoreDTOsMatchHistoryDtoSchema).nullish();
  },
  isAdmin: z.optional(z.boolean()),
  isSiteAdmin: z.optional(z.boolean()),
  deletedAt: z.iso.datetime().nullish(),
  isBanned: z.optional(z.boolean()),
  bannedAt: z.iso.datetime().nullish(),
  banReason: z.string().nullish(),
  restrictedOrganizationIds: z.array(z.uuid()).nullish(),
  preferredRole: z.string().nullish(),
  secondaryRole: z.string().nullish(),
  email: z.string().nullish(),
  isEmailVerified: z.optional(z.boolean()),
  hasPassword: z.optional(z.boolean()),
  isImpersonating: z.optional(z.boolean()),
  actorUserId: z.string().nullish(),
  actorDisplayName: z.string().nullish(),
});
